require("@babel/polyfill");
import unity from '../node_modules/uhm-unity-theme-core/dist/unity-theme-core.min.css';
import scss from './scss/styles.scss';
import scripts from './js/scripts.js';
import contactforms from './js/contact-forms.js';
import React from "react";
import ReactDOM from "react-dom";
import ReactHabitat from 'react-habitat';
import VideoLauncher from './components/video/video-launcher.js';

class UhmApp extends ReactHabitat.Bootstrapper {
    constructor() {
        super();

        // Create a new container builder:
        const builder = new ReactHabitat.ContainerBuilder();

        // Register a component:
        builder.register(VideoLauncher).as('UhmVideoLauncher');

        // Finally, set the container:
        this.setContainer(builder.build());
    }
}
// Always export a 'new' instance so it immediately evokes:
export default new UhmApp();